/*
 * Created by Joseph Saliba on 5/27/17.
 */
import { Factory } from '../../services/Factory';
import angular from "angular";

export interface IChildWindowScope extends angular.IScope {
}

export interface IChildWindowAttributes extends angular.IAttributes {
  template: string;
  toggle: string;
}

export class ChildWindow implements angular.IDirective {
  public restrict: string = 'A';
  public replace: boolean = false;
  public scope = false;
  public compile: angular.IDirectiveCompileFn;

  constructor($rootScope, $compile, $window, $templateCache, $parse) {
    this.compile = (element, attributes: IChildWindowAttributes) => {
      return {
        pre: (scope: IChildWindowScope) => {
          let childWindow;
          let cleanedUp = false;
          let closedPollInterval;

            const unbindCallback = () => {
              // Chrome doesn't reliably fire the popup's `unload`/`onunload` event
              // for a programmatic window.close() (see childWindowClose below), so
              // this can also be invoked directly instead of via onunload — guard
              // against running twice if onunload *does* still fire afterwards.
              if (cleanedUp) {
                return;
              }
              cleanedUp = true;

              if (closedPollInterval) {
                clearInterval(closedPollInterval);
                closedPollInterval = null;
              }

              // Destroy child scopes accumulated by $compile to prevent orphaned watchers.
              let child = (scope as any).$childHead;
              while (child) {
                const next = child.$nextSibling;
                child.$destroy();
                child = next;
              }

              $parse(attributes.toggle).assign($rootScope, false);

            $rootScope.$applyAsync();

            $rootScope.$broadcast(attributes.toggle, false);
          };

          // Exposed on $rootScope (not the local `scope`) so callers on
          // *either* ResourceController instance — inline or child-window —
          // can run the reattach logic directly, rather than relying solely
          // on the popup's onunload firing.
          $rootScope['_childWindowClose'] = () => {
            unbindCallback();
            if (childWindow && !childWindow.closed) {
              childWindow.close();
            }
          };

          const initializeChildWindowAsync = () => {
            childWindow.onunload = unbindCallback;

            // Copy all stylesheets from the parent window into the child.
            const childHead = childWindow.document.head;
            Array.from(document.head.querySelectorAll('link[rel="stylesheet"], style')).forEach(node => {
              childHead.appendChild(childWindow.document.importNode(node, true));
            });

            $compile(angular.element(childWindow.document).contents())(scope);

            // Trigger a digest so Angular propagates current scope state
            // (resource, filePath, etc.) to the newly compiled child DOM.
            // advancedViewer's $watch("filePath") fires here and loads the
            // resource; if HTTP calls haven't completed yet, InitializeScope's
            // own $timeout triggers another digest when they do.
            $rootScope.$applyAsync();

            if (scope['_reloadCurrent']) {
              scope['_reloadCurrent']();
            }
          };

          const openWindow = () => {
            // Reset the one-shot cleanup guard for this new popup instance —
            // otherwise a second detach cycle's unbindCallback would see
            // cleanedUp still true from the first close and no-op, leaving
            // viewerDetached stuck true with no live popup to reattach to.
            cleanedUp = false;

            $window.current = childWindow = $window.open(attributes.template, '_blank', "menubar=no, status=no, toolbar=no, location=no, fullscreen=yes", false);
            childWindow.onload = initializeChildWindowAsync;

            // `onunload` alone is not reliable for detecting a user-initiated
            // popup close in Chrome, so also poll `closed` as a fallback —
            // otherwise closing the popup via its own window controls (rather
            // than the in-app "pop in" button) can leave viewerDetached stuck
            // true with no live popup to reattach to.
            closedPollInterval = setInterval(() => {
              if (childWindow.closed) {
                unbindCallback();
              }
            }, 500);
          };

          $rootScope.$watch(attributes.toggle, state => {
            if (state) {
              if (childWindow && !childWindow.closed) {
                return;
              }
              openWindow();
            }
          });
        }
      };
    }
  }
}

frontendApp.directive("iioChildWindow", ["$rootScope", "$compile", "$window", "$templateCache", "$parse", Factory.Create(ChildWindow)]);
